import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserSettingsStateService } from '../shared/user-settings-state.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-einstellungen',
  templateUrl: './einstellungen.component.html',
  styleUrls: ['./einstellungen.component.scss'],
})
export class EinstellungenComponent implements OnInit, OnDestroy {
  settingsForm: FormGroup;
  paginatorOptions: number[] = [10, 25, 50];

  settingsInitialized$ = this.userSettingsStateService.isInitialized$;

  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private userSettingsStateService: UserSettingsStateService,
  ) {
    this.settingsForm = this.fb.group({
      itemsPerPage: [10],
      newsletterOptIn: [false],
    });
  }

  ngOnInit(): void {
    this.userSettingsStateService.maxProceduresPerPage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.settingsForm.get('itemsPerPage').setValue(value));

    this.userSettingsStateService.newsletterOptIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.settingsForm.get('newsletterOptIn').setValue(value));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateItemsPerPage(): void {
    const itemsPerPage = this.settingsForm.get('itemsPerPage').value;
    this.userSettingsStateService.updatePageSize(itemsPerPage).subscribe();
  }

  updateNewsletterOptIn(): void {
    const newsletterOptIn = this.settingsForm.get('newsletterOptIn').value;
    this.userSettingsStateService.updateNewsletterOptIn(newsletterOptIn).subscribe();
  }
}
